import React from 'react';
import { SpinnerIcon } from '../icons';

interface ActivityStatusProps {
  label: string;
  icon?: React.ReactNode;
  // Inactive statuses are kept as history (e.g. Snowflake steps) and must not keep animating.
  active?: boolean;
}

const ActivityStatus: React.FC<ActivityStatusProps> = ({ label, icon, active = true }) => (
  <div
    className={`cv-status${active ? ' cv-status--active' : ''}`}
    role={active ? 'status' : undefined}
    aria-live={active ? 'polite' : undefined}
  >
    {icon ?? <SpinnerIcon size={14} />}
    <span className="cv-status__label">{label}</span>
  </div>
);

export default ActivityStatus;
